import React from 'react';
import '../styles/menu.css';

// 이미지 임포트
import miningImage from '../assets/images/menu/LockMenu0.png';
import autoHuntingImage from '../assets/images/menu/LockMenu1.png';
import moveToEarnImage from '../assets/images/menu/LockMenu2.png';
import pvpImage from '../assets/images/menu/LockMenu3.png';
import inviteImage from '../assets/images/menu/invite.png';
import inventoryImage from '../assets/images/menu/inventory.png';
import titleImage from '../assets/images/login/Logo.png'; // 타이틀 이미지
import headerImage from '../assets/images/menu/Header.png'; // 헤더 이미지
import logoutImage from '../assets/images/inventory/Btn_Close.png';

const MenuPage = ({ onNavigateInventory, handleLogout }) => {
  return (
    <div className="menu-page">
      {/* 상단 헤더 */}
      <div className="menu-header">
        <img src={headerImage} alt="Header Background" className="menu-header-bg" />
        <img src={titleImage} alt="The Adena" className="menu-title-image" />
        <button className="menu-logoutButton" onClick={handleLogout}>
          <img src={logoutImage} alt="로그아웃" />
        </button>
      </div>

      {/* 메뉴 카드 (가로 정렬) */}
      <div className="menu-grid-horizontal">
        <div className="menu-card">
          <img src={miningImage} alt="Mining" className="menu-card-image" />
        </div>
        <div className="menu-card">
          <img src={autoHuntingImage} alt="Auto Hunting" className="menu-card-image" />
        </div>
        <div className="menu-card">
          <img src={moveToEarnImage} alt="Move To Earn" className="menu-card-image" />
        </div>
        <div className="menu-card">
          <img src={pvpImage} alt="PVP" className="menu-card-image" />
        </div>
      </div>

      {/* 하단 버튼 (오른쪽 하단 가로 정렬) */}
      <div className="menu-buttons">
        <div className="menu-button">
          <img src={inviteImage} alt="Invite" className="menu-button-icon1" />
        </div>
        <div className="menu-button" onClick={onNavigateInventory}>
          <img src={inventoryImage} alt="Inventory" className="menu-button-icon2" />
        </div>
      </div>
    </div>
  );
};

export default MenuPage;